import React from 'react';
import PropTypes from 'prop-types';

import statusOptions from './CurationProfileStatusOptions';


class CurationProfileStatusLabel extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let label = '';

        statusOptions.forEach((status) => {
            if (this.props.status === status['key']){
                label = status['label'];
            }
        });

        return <span data-bt="status_label">{label}</span>;
    }
}


CurationProfileStatusLabel.propTypes = {
    status: PropTypes.number.isRequired
};

export default CurationProfileStatusLabel;
